import * as React from 'react';

interface IAnimatedSvgProps {
    percentComplete: number,
    className?: string
}

export const Hamburger = (props: IAnimatedSvgProps) => {
    return (
        <svg className={props.className} viewBox="0 0 260 260" preserveAspectRatio="none">

            <circle cx="120" cy="120" r="120" className="box-shadow" fill="var(--deep-orange)" />

            <g stroke="currentColor" strokeWidth={12} transform={"translate(70, 50) rotate(" + (90 * props.percentComplete) + ", 50, 50)"}>
                <line
                    x1={0} y1={20 - 20 * props.percentComplete}
                    x2={100} y2={20 + 80 * props.percentComplete} />

                <line
                    x1={0} y1={50}
                    x2={100} y2={50}
                    opacity={1 - 1 * props.percentComplete} />


                <line
                    x1={0} y1={80 + 20 * props.percentComplete}
                    x2={100} y2={80 - 80 * props.percentComplete} />

            </g>

            <text stroke="white" fill="white" fontSize={42} fontWeight={"normal"} textAnchor={"middle"} x={120} y={190}>Menu</text>
        </svg>
    );
};

interface IAnimatedProps {
    duration: number,
    startTicks: number,
    reverse: boolean,
    onComplete: () => void,
    className: string,
    steps?: number
}

export const AnimatedHamburger = (props: IAnimatedProps) => {
    const [percentageComplete, setPercentageComplete] = React.useState(1);
    const currentTicks = () => new Date().getTime();
    var interval: NodeJS.Timeout | null;

    const getPercentComplete = () => {
        var pct = props.duration === 0 ? 1 : (currentTicks() - props.startTicks) / props.duration;

        return pct > 1 ? 1 : pct < 0 ? 0 : pct;
    };

    const stop = () => {
        if (interval) {
            clearInterval(interval);
        }

        props.onComplete();
    };

    const animate = () => {
        var pct = getPercentComplete();

        if (pct > 1) {
            stop();
            setPercentageComplete(1);
        } else {
            setPercentageComplete(pct < 0 ? 0 : pct);
        }
    };

    const start = () => {
        if (!interval && (props.startTicks + props.duration) > currentTicks()) {
            interval = setInterval(animate, props.duration / (props.steps ?? 10));
        }

        return stop;
    }

    React.useEffect(start, [props.startTicks, props.reverse]);

    return (<Hamburger className={props.className} percentComplete={props.reverse ? 1 - percentageComplete : percentageComplete} />)
};